import { ReactNode } from 'react';
import styled, { Sizes, ThemedStyledProps } from 'styled-components';
import { TinkPaletteColors, TinkTheme } from '../../providers/ThemeProvider/theme';

interface StyleProps {
  bold?: boolean;
  color?: TinkPaletteColors;
  fontSize?: Sizes;
}

interface AProps extends StyleProps {
  children?: ReactNode;
  href: string;
  newTab?: boolean;
}

export const getStyleRulesForA = (props: ThemedStyledProps<StyleProps, TinkTheme>) => {
  return `
    color: ${
      props.color ? props.theme.palette[props.color].main : props.theme.palette.secondary[600]
    };
    font-weight: ${
      props.bold ? props.theme.font.weights.semiBold : props.theme.font.weights.regular
    };
    ${props.fontSize ? `font-size: ${props.theme.sizes[props.fontSize]};` : ''}
    text-decoration: none;
    &:hover {
      color: ${
        props.color ? props.theme.palette[props.color][800] : props.theme.palette.secondary[900]
      };
    }`;
};

export const A = styled.a.attrs<AProps>(({ newTab }) => ({
  target: newTab ? '_blank' : undefined,
  rel: newTab ? 'noopener' : undefined,
}))<AProps>`
  ${getStyleRulesForA}
`;
